import { apiClient, isRemoteApiEnabled } from '@/api/client'

/**
 * Admin auth seam. The storefront has no customer accounts — these endpoints
 * exist only for staff log-in. Backend wraps responses in
 * `{ success, data, ... }`; the axios response interceptor unwraps to `data`
 * before reaching here, so callers see the inner payload directly.
 */

export async function loginUser({ email, password }) {
  if (!isRemoteApiEnabled()) {
    throw new Error('Auth requires VITE_API_BASE_URL to be set')
  }
  return apiClient.post('/auth/login', { email, password })
}

export async function refreshAccessToken(refreshToken) {
  return apiClient.post('/auth/refresh', { refreshToken })
}

export async function logoutUser() {
  return apiClient.post('/auth/logout')
}

export async function getCurrentUser() {
  return apiClient.get('/users/me')
}
